import React from 'react'
import { reduxForm } from 'redux-form'
import shouldAsyncValidate from 'utils/shouldAsyncValidate'
import validator from 'utils/asyncValidator'
import { validationSchema } from 'modules/Forms/MediaPlanner/yd/validationSchema'
import Form from 'modules/Forms/MediaPlanner'
import config from 'modules/Forms/MediaPlanner/yd/config'

const MediaPlannerForm = (props) => <Form {...props} />

const MediaPlannerFormRedux = reduxForm({
  form: 'media-planner',
  enableReinitialize: true,
  shouldAsyncValidate,
  touchOnBlur: true,
  touchOnChange: true,
  asyncValidate: validator(validationSchema),
  initialValues: Object.entries(config.fields).reduce(
    (acc, [key, { sub_field = null, value }]) => ({
      ...acc,
      [key]: value,
      ...(sub_field ? { [sub_field.name]: sub_field.value } : {}),
    }),
    {},
  ),
})(MediaPlannerForm)

export default MediaPlannerFormRedux
